import React, { Component } from 'react';
import EventListener from 'react-event-listener';
import keycode from 'keycode';
import Calendar from 'material-ui/DatePicker/Calendar';
import Clock from 'material-ui/TimePicker/Clock';
import Dialog from 'material-ui/Dialog';
import Popover from 'material-ui/Popover/Popover';
import PopoverAnimationFromTop from 'material-ui/Popover/PopoverAnimationVertical';
import { dateTimeFormat } from 'material-ui/DatePicker/dateUtils';
import Button from '../Button';
import TextField from 'material-ui/TextField';

class DatePickerDialog extends Component {

  static defaultProps = {
    DateTimeFormat: dateTimeFormat,
    cancelLabel: 'Zavřít',
    container: 'dialog',
    locale: 'cs-CZ',
    okLabel: 'OK',
  };

  state = {
    open: false,
    time: ''
  };

  show = () => {
    if (this.props.onShow && !this.state.open) {
      this.props.onShow();
    }

    this.setState({
      open: true
    });
  };

  dismiss = () => {
    if (this.props.onDismiss && this.state.open) {
      this.props.onDismiss();
    }

    this.setState({
      open: false
    });
  };

  handleTouchTapDay = () => {
    if (this.props.autoOk) {
      setTimeout(this.handleTouchTapOk, 300);
    }
  };

  handleTouchTapCancel = () => {
    this.dismiss();
  };

  handleRequestClose = () => {
    this.dismiss();
  };

  handleTouchTapOk = () => {
    const { dateOnly } = this.props;
    if (this.props.onAccept && !this.refs.calendar.isSelectedDateDisabled()) {
      const date = this.refs.calendar.getSelectedDate();
      const time = {
        hours: (dateOnly ? 0 : this.parseTime(this.state.time).hours),
        minutes: (dateOnly ? 0 : this.parseTime(this.state.time).minutes)
      };
      this.props.onAccept(new Date(date.getFullYear(), date.getMonth(), date.getDate(), time.hours, time.minutes));
    }

    this.setState({
      open: false
    });
  };

  handleWindowKeyUp = (event) => {
    switch (keycode(event)) { // eslint-disable-line default-case
      case 'enter':
        this.handleTouchTapOk();
        break;
    }
  };

  formatTime = (d) => {
    const date = d && d instanceof Date ? d : new Date();
    if (!date || !(date instanceof Date) || Number.isNaN(date.getTime())) return '';

    const pad = (n) => String(n).padStart(2, '0');
    return `${pad(date.getHours())}:${pad(date.getMinutes())}`;
  };

  parseTime = (timeString) => {
    const [hours, minutes, seconds] = timeString.split(':').map(Number);
    if (
      Number.isNaN(hours) || hours < 0 || hours > 23 ||
      Number.isNaN(minutes) || minutes < 0 || minutes > 59 ||
      Number.isNaN(seconds) || seconds < 0 || seconds > 59
    ) {
      return null;
    }
    return { hours, minutes, seconds };
  }

  render() {
    const {
      DateTimeFormat,
      autoOk,
      cancelLabel,
      container,
      containerStyle,
      disableYearSelection,
      initialDate,
      firstDayOfWeek,
      locale,
      maxDate,
      minDate,
      mode,
      okLabel,
      onAccept, // eslint-disable-line no-unused-vars
      onDismiss, // eslint-disable-line no-unused-vars
      onShow, // eslint-disable-line no-unused-vars
      shouldDisableDate,
      style, // eslint-disable-line no-unused-vars
      timeFormat,
      dateOnly,
      ...other
    } = this.props;

    const { open } = this.state;
    const styles = {
      dialogContent: {
        width: dateOnly ? 310 : 500
      },
      dialogBodyContent: {
        padding: 0,
        minHeight: dateOnly ? 161 : 409,
        minWidth: dateOnly ? 310 : 310
      }
    };

    if(!dateOnly && !this.state.time && initialDate) {
      this.setState({ time: this.formatTime(initialDate) });
    }

    const actions = [
      <Button
        key={0}
        label={okLabel}
        style={{ color: 'white' }}
        onTouchTap={this.handleTouchTapOk}
      />,
      <Button
        key={1}
        label={cancelLabel}
        style={{ marginLeft: 5, color: 'white' }}
        onTouchTap={this.handleTouchTapCancel}
      />
    ];

    const Container = (container === 'inline' ? Popover : Dialog);

    return (
      <div {...other} ref="root">
        <Container
          actions={actions}
          anchorEl={this.refs.root} // For Popover
          animation={PopoverAnimationFromTop} // For Popover
          bodyStyle={styles.dialogBodyContent}
          contentStyle={styles.dialogContent}
          ref="dialog"
          repositionOnUpdate
          open={open}
          onRequestClose={this.handleRequestClose}
          style={Object.assign(styles.dialogBodyContent, containerStyle)}
        >
          <EventListener
            target="window"
            onKeyUp={this.handleWindowKeyUp}
          />
          <div className="dateTimeDialogContainer">
            <Calendar
              autoOk={autoOk}
              DateTimeFormat={DateTimeFormat}
              cancelLabel={cancelLabel}
              disableYearSelection={disableYearSelection}
              firstDayOfWeek={firstDayOfWeek}
              initialDate={initialDate}
              locale={locale}
              onTouchTapDay={this.handleTouchTapDay}
              maxDate={maxDate}
              minDate={minDate}
              mode={mode}
              open={open}
              ref="calendar"
              onTouchTapCancel={this.handleTouchTapCancel}
              okLabel={false}
              shouldDisableDate={shouldDisableDate}
            />
            {!dateOnly &&
            <div className="timeWidget">
                <TextField type="time"
                           value={this.state.time}
                           inputProps={{ step: 1 }}
                           onChange={(e) => this.setState({ time: e.target.value })}
                />
            </div>}
          </div>
        </Container>
      </div>
    );
  }
}

export default DatePickerDialog;
